import React, { useState } from "react";
import "./styles.css";
import { toast } from "react-toastify";
import ImagemPushNotification from "../../assets/imagem-push.png";
//import env from "react-dotenv";

import ApiPushLinkDoBem from "../../services/api-Push";
import LinksRoutes from "./components/rotas";
import NavigateSelect from "./components/NavigateSelect";

export default function Painel() {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [clickActionUrl, setClickActionUrl] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [selectedOption, setSelectedOption] = useState("default");
  const [loading, setLoading] = useState(false);

  const sendPushNotification = async () => {
    if (title === "" || body === "") {
      alert("Por favor, preencher título e descrição ");
      return;
    }

    if (imageUrl) {
      const image = new Image();
      image.src = imageUrl;

      image.onload = function () {
        const imageSize = this.width * this.height;
        const imageSizeInKB = imageSize / 1024;

        if (imageSizeInKB > 300) {
          toast.error("Desculpe, a imagem não pode ser maior que 300KB.");
          return;
        }

        sendNotification();
      };

      image.onerror = function () {
        toast.error("Erro ao carregar a imagem.");
        return;
      };
    } else {
      sendNotification();
    }
  };

  const sendNotification = async () => {
    setLoading(true);
    const data = {
      title: title,
      body: body,
      clickAction: clickActionUrl,
    };

    // Send the notification to all tokens
    ApiPushLinkDoBem.post("/push", data)
      .then((response) => {
        //console.log("Notificação enviada com sucesso!");
        toast.success("Notificação enviada com sucesso!");
        setTitle("");
        setBody("");
        setClickActionUrl("");
        // setImageUrl("");
        setLoading(false);
      })
      .catch((error) => {
        console.error("Erro ao enviar notificação:", error);
        toast.error("Erro ao enviar notificação");
        setLoading(false);
      });
  };

  return (
    <div className="scrollPush">
      <div className="areaBotaoDesconectar">
        <LinksRoutes />
        <NavigateSelect
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
        />
      </div>

      <div className="container">
        <div className="col">
          <img
            src={ImagemPushNotification}
            alt="Imagem de notificação push"
            className="ImagemPushNotification"
          />

          <p className="imageDescricao">Push Notifications ease!</p>
        </div>
        <div className="colNoFlexCenter">
          <h2 className="title">Notificação</h2>

          <div className="boxInput">
            <label>Título da notificação</label>
            <input
              type="text"
              value={title}
              placeholder="Insira o título da notificação"
              maxLength={140}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
          <div className="boxInput">
            <label>Descrição da notificação</label>
            <input
              type="text"
              placeholder="Insira a descrição da notificação"
              value={body}
              maxLength={600}
              onChange={(e) => setBody(e.target.value)}
            />
          </div>
          <div className="boxInput">
            <label>Click Action URL (opcional)</label>
            <input
              type="text"
              placeholder="URL de redirecionamento"
              value={clickActionUrl}
              onChange={(e) => setClickActionUrl(e.target.value)}
            />
          </div>

          {/* 
          <div className="boxInput">
            <label>Imagem da notificação (opcional)</label>
            <input
              type="text"
              placeholder="https://www.sua-imagem.com/image.png"
              value={imageUrl}
              onChange={(e) => setImageUrl(e.target.value)}
            />
          </div>
         */}

          <button onClick={sendPushNotification} className="buttonSendPush">
            {loading ? "Enviando..." : "Enviar"}
          </button>
        </div>
      </div>
    </div>
  );
}
